module.exports = __webpack_public_path__ + "img/p6-p1-molihua.9c4272f5.png";